// API Configuration
// export const BASE_API = "http://localhost:8000"
//export const BASE_API = "https://seal-app-rutmf.ondigitalocean.app"
export const BASE_API = "https://backoffice.lizen.com.ar"

export const MISTA_API_KEY="s1_api_eVkwutVgDB9k0rDYbMrfn3bTAGceLQ428dRxBrH5GiSLHSxYBV7xgM7dEk4X9xPApPZnXzupBxqPWh7qQ1hE1VroR9FIIDf5jV8MlIe5Xx0tQL3Z7nRiLsTuiFFscrhQTis_kKAp4_0TJYfc9-GaoAnHxRLYbqrhV_dmb3zObbw=";
export const API_MISTA_URL = "https://app.sysone.com/policy-life/v1";
export const ID_ASEGURADORA_MISTA = 31;
export const PASSWORD_RESET_MAIL = 'vzenon@lizen.com.ar';
export const LOGRAR_SEGUROS_API_URL = "https://cuentaautomatismo.app.n8n.cloud/webhook";
export const LOGRAR_SEGUROS_X_USER = "orion";

// LocalStorage/SessionStorage Keys
export const STORAGE_KEYS = {
    TOKEN: "token",
    HASH: "hash",
    INTERVAL_ID: "intervalId",
    NOTIFICATION_DATA: "notificationData",
    CHAT_MENSAJES: "chat_mensajes_v1"
};

// Timeouts and Intervals (in milliseconds)
export const TIMEOUTS = {
    NOTIFICATION_CHECK_INTERVAL: 5000, // 5 seconds
    TOAST_AUTO_CLOSE: 1000, // 1 second
    DEFAULT_DELAY: 1000, // 1 second
};

// Pagination and Limits
export const LIMITS = {
    DEFAULT_PAGINATION: 1000,
    MAX_ITEMS_PER_PAGE: 1000,
};

// Date Formats
export const DATE_FORMATS = {
    NOTIFICATION: "DD-MM-YYYY H:mma",
    DATETIME: "YYYY-MM-DD HH:mm:ss",
    DATETIME_DISPLAY: "DD/MM/YYYY HH:mma",
    DATE_ONLY: "YYYY-MM-DD",
    ISO_DATE: "YYYY-MM-DD", // For toISOString().slice(0, 10)
};